export default __webpack_public_path__ + "static/media/Ether.bccad123.svg";